import { FormQuestionBase } from './_form_question_base';
import { safeJsonParse } from '@visiba/std';
import type { QuestionApiModel } from '@api_patient/generated/clientv2/models';
import { DynamicFormAnswer } from '@api_patient/dynamic_forms_api.service';
import { CellulaFormSubmitData } from '@cellula/react';

export class FormQuestionTypeYesNo extends FormQuestionBase {
	public readonly type = 'YesNo';
	public readonly trueLabel: string;
	public readonly falseLabel: string;
	public defaultValue: 'true' | 'false' | undefined = undefined;

	constructor(question: QuestionApiModel) {
		super(question);

		// TODO PAT-426: Allow null?
		this.trueLabel = question.TrueLabel ?? '';
		// TODO PAT-426: Allow null?
		this.falseLabel = question.FalseLabel ?? '';
	}

	// TODO: Use this when not injected anymore...
	// public override getAnswer(formElements: FormElements<string>): AnswerApiModel {
	public getAnswer(pageData: CellulaFormSubmitData): DynamicFormAnswer {
		const formValue = pageData[this.id] ?? null;
		const value = safeJsonParse<boolean | null>(formValue);

		return this.createAnswerApiModel({
			boolValue: value,
		});
	}

	// TODO: Use this when not injected anymore...
	// public override setDefault(allAnswers: Readonly<AnswerApiModel[]>): void {
	public setDefault(allAnswers: Readonly<DynamicFormAnswer[]>): void {
		const answer = allAnswers.find((answer) => answer.questionId === this.composeQuestionId());
		this.defaultValue = answer?.boolValue === false ? 'false' : answer?.boolValue ? 'true' : undefined;
	}
}
